export default function MobileRes() {
  return (
    <>
      <i className="bi bi-list mobile-nav-toggle d-xl-none"></i>
    </>
  )
}
